import {
  InitialState,
  OPEN_CART_STORE,
  CLOSE_CART_STORE,
  UPDATE_ORIGIN_CLICK_ADD_TO_CART,
  ModalCartState,
  ModalCartActions,
} from './types'

const ModalCartReducer = (state: ModalCartState = InitialState, action: ModalCartActions): ModalCartState => {
  switch (action.type) {
    case OPEN_CART_STORE: {
      return {
        ...state,
        open: true,
      }
    }
    case CLOSE_CART_STORE: {
      return {
        ...state,
        open: false,
      }
    }
    case UPDATE_ORIGIN_CLICK_ADD_TO_CART: {
      return {
        ...state,
        pathToClickAddToCart: action.payload,
      }
    }
    default:
      return state
  }
}

export default ModalCartReducer
